import React from 'react'
import { useAuth } from '../hooks/useAuth'

/**
 * Reusable Field-Level Security primitive.
 * Obfuscates or hides sensitive metrics (e.g. Revenue, Cost, CTC, Margins)
 * if the current actor lacks the specified privilege.
 * Admins automatically bypass all checks.
 */
export default function SecureField({
  privilege,
  anyOf,
  fallback = 'Restricted',
  obfuscated = false,
  children,
}) {
  const { hasPrivilege, hasAnyPrivilege, isAdmin } = useAuth()

  const allowed = isAdmin || (anyOf ? hasAnyPrivilege(anyOf) : privilege ? hasPrivilege(privilege) : true)

  if (!allowed) {
    if (obfuscated) {
      return <span className="font-mono text-on-surface-variant/50 select-none tracking-widest">••••••</span>
    }
    return (
      <span className="inline-flex items-center text-xs font-semibold text-on-surface-variant/60 bg-surface-container px-2 py-0.5 rounded">
        {fallback}
      </span>
    )
  }

  return <>{children}</>
}
